import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	titleText: {
		display: 'inline-block',
		marginLeft: theme.spacing(1),
		whiteSpace: 'nowrap'
	},
	additionalActionsContainer: {
		display: 'inline-flex',
		width: 'auto',
		textAlign: 'left'
	},
	scrollBarContainer: {
		overflowX: 'auto',
		position: 'sticky',
		top: 60,
		zIndex: 1050,
		backgroundColor: 'white'
	},
	scrollBar: {
		height: '20px',
		backgroundColor: 'white',
		zIndex: 1050,
		[theme.breakpoints.down('sm')]: {
			height: 0
		}
	}
}));
